import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'do0075',
    ecrans: ['00-2']
});
